module.exports = __webpack_public_path__ + "static/media/S-10.3d72a4d2.mp3";